<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-13.818.09A3.821 3.821 0 0 1 12 8.274c.643 0 1.254.159 1.782.445l.929-.929A5.047 5.047 0 0 0 12 7a5.09 5.09 0 0 0-5.09 5.09H5l2.545 2.546 2.546-2.545H8.18Zm8.272-2.545-2.545 2.546h1.91A3.821 3.821 0 0 1 12 15.909c-.643 0-1.254-.159-1.782-.445l-.929.929c.783.496 1.712.789 2.711.789a5.09 5.09 0 0 0 5.09-5.091H19l-2.546-2.546Z"
      clip-rule="evenodd"
    />
  </svg>
</template>